// extracted by mini-css-extract-plugin
export var isPrintedCell = "_yb-1";
export var printerIcon = "_yb-0";